export default {
    domains: {
        status: {
            verified: 'verified',
            unverified: 'unverified',
        },
        notification: {
            verified: 'Your domain has been verified successfully!',
            unverified: 'Your domain has not been verified yet',
        },
        card: {
            title: 'Trusted Domains',
            description: 'Increase security by adding trusted domains, so we will know that you are their owner.',
        },
        cancel: 'Cancel',
        domain: 'Domain',
        verified: 'Verified',
        'add-domain': 'Add Domain',
        'remove-domain': 'Remove Domain',
        'verify-domain': 'Verify Domain',
        'verify-later': 'Verify later',
        remove: 'Remove',
        verify: 'Verify',
        'add-modal': {
            title: 'Add domain',
        },
        'verify-modal': {
            title: 'Verify domain',
            info: 'To verify your domain, you need to add a record to your DNS zone',
            step1: 'Sign to your DNS provider',
            step2: 'add the following TXT record',
            step3: 'Press verify below',
            name: 'Name',
            value: 'Value',
        },
        'remove-confirm-modal': {
            title: 'Remove domain?',
            content: 'Do you really want to remove {domain}?',
        },

    },
}
